import React, { useEffect, useState } from 'react'

import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Table } from 'antd';
import moment from "moment";
import { allapiAction } from '../../Redux/common/action';
import NewHeader from '../Layout/NewHeader';
import NewSidebar from '../Layout/NewSidebar';

function AllTeams() {


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pagev = searchParams.get("page");
    const searchData = searchParams.get("search");

    const page = pagev == null ? 1 : pagev;
    const search = searchData == null ? "" : searchData;
    const [pages, setPage] = useState(1);
    const order_list = useSelector((state) =>
        state?.allapi?.user_all_team ? state?.allapi?.user_all_team : {}
      );
    const listdata = order_list?.docs ? order_list?.docs : [];

    useEffect(() => {
        // if (search) {
        //   dispatch(allapiAction.getSearchOrdervendor({ page: page, key: search }));
        // } else {
          dispatch(allapiAction.userallteamlist({pageNumber : page}));
          // dispatch(allapiAction.userallteamlistbySupport({ pageNumber: page }));
  
        // }
        // dispatch(allapiAction.getInvoceDetails());
        return () => {};
      }, [location]);

    const hendlePahegi = (e) => {
        setPage(e);
    
        console.log(location);
    
        navigate("/all-team?page=" + e + "&&search=" + search);
    
        
      };
      const columns = [
        {
          title: "S.No.",
          dataIndex: "sno",
          key: "sno",
          className: "table_first_col",
          render: (value, item, index) => (page - 1) * 10 + index + 1,
        },
        // {
        //   title: "Image",
        //   dataIndex: "referId",
        //   key: "referId",
        //   className: "table_action_col",
        //   render: (value, item, index) => {
        //     return (
        //       <>
        //         {/* <Tooltip title="Contact"> */}
        //         <span
        //           className="cursor-pointer coustomNevc"
        //           // onClick={() => navigate(`/user-details/${item?.referId}`)}
        //         >
        //           {/* {item?.user_id?.fullName} */}
        //           <img
        //             src={URL?.API_BASE_URL + item?.image}
        //             alt=""
        //             style={{ width: "70px" }}
        //           />
        //           {/* <p> {item?.user_id?.referId}</p> */}
        //         </span>
        //       </>
        //     );
        //   },
        // },
        {
          title: "Name",
          dataIndex: "fullName",
          key: "fullName",
          className: "table_action_col",
        },
        {
          title: "referId",
          dataIndex: "referId",
          key: "referId",
          className: "table_action_col",
        },
        {
          title: "Sponser Id",
          dataIndex: "referBy",
          key: "referBy",
          className: "table_action_col",
        },
        // {
        //   title: "Support Id",
        //   dataIndex: "placmentby",
        //   key: "placmentby",
        //   className: "table_action_col",
        // },
        // {
        //   title: "Support Id",
        //   dataIndex: "placmentby",
        //   key: "placmentby",
        //   className: "table_action_col",
        // },
    
        // {
        //   title: "Image",
        //   dataIndex: "image",
        //   key: "image",
        //   className: "table_action_col",
        //   render: (value, item, index) => {
        //     return (
        //       <>
        //         <div style={{ width: "100px" }}>
        //           <img
        //             style={{ width: "100%" }}
        //             src={URL?.API_BASE_URL + item?.featureImage}
        //             alt=""
        //           />
        //         </div>
        //       </>
        //     );
        // //   },
        // },
    
        // {
        //   title: "Status",
        //   dataIndex: "status",
        //   key: "status",
        //   className: "table_action_col",
        //   render: (value, item, index) => {
        //     return (
        //       <>
        //         {/* <Tooltip title="Contact"> */}
        //         <span
        //           className="cursor-pointer "
        //           // onClick={() => navigate(`/user-details/${item?.referId}`)}
        //         >
        //           {item?.status}
        //         </span>
        //       </>
        //     );
        //   },
        // },
        // {
        //   title: "Address",
        //   dataIndex: "city",
        //   key: "city",
        //   className: "table_action_col",
        //   render: (value, item, index) => {
        //     return (
        //       <>
        //         {/* <Tooltip title="Contact"> */}
        //         <span
        //           className="cursor-pointer "
        //           // onClick={() => navigate(`/user-details/${item?.referId}`)}
        //         >
        //           {item?.city},{item?.state},{item?.pincode}
        //         </span>
        //       </>
        //     );
        //   },
        // },
        // {
        //   title: "Name",
        //   dataIndex: "title",
        //   key: "title",
        // },
        // {
        //   title: "Status",
        //   dataIndex: "status",
        //   key: "status",
        //   className: "table_action_col",
        //   render: (value, item, index) => {
        //     return (
        //       <>
        //         <Tooltip title={item?.status}>
        //           <button
        //             className={
        //               item?.status == "Active"
        //                 ? "success-button ml-3"
        //                 : "delete-button ml-3"
        //             }
        //             onClick={() =>
        //               hendleToStatus(
        //                 item?._id,
        //                 item?.status == "Active" ? "Inactive" : "Active"
        //               )
        //             }
        //           >
        //             {item?.status}
        //           </button>
        //         </Tooltip>
        //       </>
        //     );
        //   },
        // },
        // {
        //   title: "Upline Id",
        //   dataIndex: "referBy",
        //   key: "referBy",
        // },
        // {
        //   title: "Number",
        //   dataIndex: "phone",
        //   key: "phone",
        // },
        // {
        //   title: "Password",
        //   dataIndex: "passwordPlan",
        //   key: "passwordPlan",
        // },
        // {
        //   title: "Wallet",
        //   dataIndex: "balance",
        //   key: "balance",
        // },
        // {
        //   title: "Wallet",
        //   dataIndex: "Wallet",
        //   key: "Wallet",
        //   className: "table_action_col",
        //   render: (value, item, index) => {
        //     return (
        //       <>
    
        //         <span
        //           className="cursor-pointer"
        //           // onClick={() => navigate(`/users/contact/${item?.id}`)}
        //         >
        //           {item?.walletId?.closeBal}
        //         </span>
        //       </>
        //     );
        //   },
        // },
        // {
        //   title: "Reffer Code",
        //   dataIndex: "referCode",
        //   key: "referCode",
        // },
        {
          title: "Created Date",
          dataIndex: "createdAt",
          key: "createdAt",
          className: "table_action_col",
          render: (value, item, index) => {
            return (
              <>
                {/* <Tooltip title="Contact"> */}
                <span
                  className="cursor-pointer"
                  // onClick={() => navigate(`/users/contact/${item?.id}`)}
                >
                  {moment(item?.createdAt).format(" DD/MM/YYYY ")}
                </span>
              </>
            );
          },
        },
        //     {
        //       title: "Status",
        //       dataIndex: "status",
        //       key: "status",
        //       className: "table_action_col",
        //       render: (value, item, index) => {
    
        //         const userRank =
        //         item?.status == '0'
        //           ? 'free'
        //           : item?.status == '1'
        //           ? 'FRANCHISE'
        //           : item?.status == '2'
        //           ? 'BARON'
        //           : item?.status == '3'
        //           ? 'COUNT'
        //           : item?.status == '4'
        //           ? 'MARQUISE'
        //           : item?.status == '4'
        //           ? 'DUKE'
        //           : 'ARCH DUKE'
        //         return (
        //           <>
    
        // <span
        //               className="cursor-pointer"
    
        //             >
        //              {userRank}
        //             </span>
    
        //           </>
        //         );
        //       },
        //     },
        // {
        //   title: "Amount",
        //   dataIndex: "sub_total",
        //   key: "sub_total",
        // },
        // {
        //   title: "Payment Mode",
        //   dataIndex: "payment_mode_name",
        //   key: "payment_mode_name",
        // },
        // {
        //   title: "Delivery status",
        //   dataIndex: "delivery_status",
        //   key: "delivery_status",
        // },
        // {
        //   title: "Order return",
        //   dataIndex: "orderretune",
        //   key: "orderretune",
        //   className: "table_action_col",
        //   render: (value, item, index) => {
        //     return (
        //       <>
        //         <span
        //           className="cursor-pointer"
        //           // onClick={() => navigate(`/users/contact/${item?.id}`)}
        //         >
        //           {item?.orderretune == "true" ? "Yes" : "No"}
        //         </span>
        //       </>
        //     );
        //   },
        // },
        // {
        //   title: "Actions",
        //   dataIndex: "action",
        //   key: "action",
        //   className: "table_action_col",
        //   render: (value, item, index) => {
        //     return (
        //       <>
        //         {/* <Tooltip title="Contact">
        //           <span
        //             className="cursor-pointer"
        //             onClick={() => navigate(`/users/contact/${item?.id}`)}
        //           >
        //             <SvgIcon.contacts className="scale-icon edit-icon" />
        //           </span>
        //         </Tooltip> */}
        //         <Tooltip title="delete">
        //           <button
        //             className="filter-button ml-3"
        //             onClick={() => showModal(item?._id)}
        //           >
        //             Delete
        //           </button>
        //         </Tooltip>
        //         <Tooltip title="Invoice">
        //           <button
        //             className="filter-button ml-3  mt-5"
        //             onClick={() => hendleToViewM(item)}
        //           >
        //             Print
        //           </button>
        //         </Tooltip>
        //         {/* <Tooltip title="View">
        //           <button
        //             className="filter-button ml-3  mt-5"
        //             onClick={() => hendleToViewProduct(item)}
        //           >
        //             View
        //           </button>
        //         </Tooltip> */}
        //       </>
        //     );
        //   },
        // },
      ];
  return (
    <div>
<NewHeader   />
<NewSidebar />
<div className="main">
  <div className="my">
    <div className="container mt-5 pt-5 mb-5 pb-5">
      <div className="tableResponsive mt-10">
        <Table
          className="table antd_table custom-table"
          dataSource={listdata}
          columns={columns}
          pagination={{
            current: parseInt(page),
            pageSize: 10,
            onChange(current, pageSize) {
              hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: order_list?.totalDocs ? order_list?.totalDocs : 0,
          }}
        />
      </div>
    </div>
    {/* STYLE TAG */}
    <style jsx="true">{`
      .my {
        background-image: linear-gradient(90deg, rgba(237, 204, 238, 0.9), rgba(162, 233, 202, 0.9), rgba(245, 247, 179, 0.9));
        background-color: rgba(255, 255, 255, 0.5); /* Add a transparent white background */
        background-blend-mode: overlay; /* Blend the background image with the color */
      }
      .custom-table {
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
        margin-top: 20px;
        min-width: 800px; /* Table ka min-width */
      }
      .custom-table .ant-table-thead > tr > th {
        background-color: #a57b2e;
        color: #fff;
        font-weight: 600;
        font-size: 16px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        padding: 16px;
      }
      .custom-table .ant-table-tbody > tr > td {
        font-size: 15px;
        padding: 14px;
        background-color: #fafafa;
        border-bottom: 1px solid #eee;
      }
      .custom-table .ant-table-tbody > tr:hover > td {
        background-color: #f0f8ff;
        transition: all 0.3s;
      }
      .custom-table .ant-pagination {
        margin-top: 20px;
        text-align: center;
      }
      .tableResponsive {
        width: 100%;
        overflow-x: auto;
      }
      @media (max-width: 768px) {
        .custom-table {
          min-width: 600px;
        }
      }
      @media (max-width: 576px) {
        .custom-table {
          min-width: 500px;
        }
      }
    `}</style>
  </div>
</div>

    </div>
  )
}

export default AllTeams
